import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import wadeIcon from "../../../components/Icons/wadeIcon.svg";
import { Button, Modal } from "react-bootstrap";
import { cn } from "../../../helpers";
import { getEmailEnable2FAService } from "../../../services/emailEnable2FA.service";
import CodeVerificationDialog from "../CodeVerifiaction/CodeVerificationDialog";
import { setIsAuthorized } from "../../../redux/login/actions";
import VerifiedAccount from "../../../components/Login/Message/VerifiedAccount/VerifiedAccount";
import { safeReadUsers } from "../../../services/auth/loginRetry";

export interface EmailVerificationProps {
  show: boolean;
  onEmailDialogHide: any;
  email: string;
  password: string;
  user_id: number;
}

const EmailVerificationDialog = (props: EmailVerificationProps) => {
  const { show, onEmailDialogHide, email, password, user_id } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [emailId, setEmail] = useState("");
  const [codeVerificationDialog, setCodeVerificationDialog] = useState(false);
  const [invalidMailId, setInvalidMailId] = useState(false);
  const [incorrectEmailInputChange, setIncorrectEmailInputChange] =
    useState(false);
  const [onSubmit, SetOnSubmit] = useState(false);

  const validateEmail = () => {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(emailId)) {
      return true;
    } else {
      return false;
    }
  };

  const onInputChange = (e: any) => {
    if (e.target.name === "email" && invalidMailId) {
      setIncorrectEmailInputChange(true);
    }
    setEmail(e.target.value);
  };

  const onGetCodeButtonClickHandler = () => {
    setIncorrectEmailInputChange(false);
    if (validateEmail()) {
      getEmailEnable2FAService(email, password, user_id);
      onEmailDialogHide();
      setCodeVerificationDialog(true);
    } else {
      setInvalidMailId(true);
    }
  };

  const onDoneButtonClick = () => {
    safeReadUsers(email, password).then((response) => {
      if (response.is_verified === false) {
        navigate("/");
        SetOnSubmit(false);
      } else {
        dispatch(setIsAuthorized(true));
        // navigate("/onboard");
        navigate("/home");
      }
    });
  };
  const onCloseIconClick = () => {
    SetOnSubmit(false);
    dispatch(setIsAuthorized(true));
    // navigate("/onboard");
    navigate("/home");
  };

  const handleSuccessSubmit = () => {
    setCodeVerificationDialog(false);
    SetOnSubmit(!onSubmit);
  };

  return (
    <div>
      <Modal
        show={show}
        backdrop="static"
        keyboard={false}
        onHide={onEmailDialogHide}
        centered
        contentClassName="tw-bg-transparent tw-border-none tw-shadow-none"
        dialogClassName="tw-max-w-xl tw-mx-4 tw-w-full md:tw-mx-auto"
      >
        <div className="tw-bg-white tw-rounded-2xl tw-shadow-2xl tw-overflow-hidden tw-flex tw-flex-col tw-relative">
          {/* Top Accent Line */}
          <div className="tw-h-2 tw-bg-gradient-to-r tw-from-[#03234a] tw-to-[#04346c] tw-w-full"></div>

          <div className="tw-p-6 md:tw-p-10 tw-flex tw-flex-col tw-items-center">
            {/* Logo */}
            <div className="tw-mb-8 tw-bg-gray-50 tw-p-4 tw-rounded-full tw-shadow-sm">
              <img src={wadeIcon} alt="WADE Logo" className="tw-h-8" />
            </div>

            {/* Title */}
            <h2 className="tw-text-[#03234a] tw-text-2xl tw-font-bold tw-mb-2 tw-text-center">
              Email Verification
            </h2>

            {/* Description */}
            <p className="tw-text-gray-500 tw-text-center tw-mb-8 tw-text-sm md:tw-text-base tw-leading-relaxed tw-max-w-sm">
              Enter the email address you'd like to receive the verification code.
            </p>

            {/* Form Content */}
            <div className="tw-w-full tw-max-w-sm tw-mb-8">
              <div className="tw-mb-4">
                <label className="tw-block tw-text-sm tw-font-bold tw-text-[#03234a] tw-mb-2">
                  Email
                </label>
                <input
                  type="email"
                  placeholder="Enter Email ID"
                  value={emailId}
                  onChange={onInputChange}
                  name="email"
                  maxLength={100}
                  className={cn(
                    "tw-w-full tw-px-4 tw-py-3 tw-rounded-xl tw-border-2 tw-bg-gray-50 tw-outline-none tw-transition-all",
                    invalidMailId || incorrectEmailInputChange
                      ? "tw-border-red-300 focus:tw-border-red-500 tw-text-red-900 placeholder:tw-text-red-300"
                      : "tw-border-gray-200 focus:tw-border-[#03234a]"
                  )}
                />
                {invalidMailId && (
                  <p className="tw-mt-2 tw-text-sm tw-text-red-600 tw-font-medium">
                    Invalid Email. Please try again.
                  </p>
                )}
              </div>
            </div>

            {/* Action Button */}
            <Button
              className="tw-w-full tw-max-w-sm tw-h-12 tw-bg-[#03234a] tw-text-white tw-font-bold tw-tracking-wide tw-rounded-xl hover:tw-bg-[#052d5e] focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-offset-2 focus:tw-ring-[#03234a] disabled:tw-opacity-50 disabled:tw-cursor-not-allowed tw-transition-all tw-shadow-lg hover:tw-shadow-xl hover:-tw-translate-y-0.5 active:tw-translate-y-0"
              onClick={onGetCodeButtonClickHandler}
              disabled={emailId === ""}
            >
              Send
            </Button>
          </div>
        </div>
      </Modal>
      {codeVerificationDialog && (
        <CodeVerificationDialog
          show={codeVerificationDialog}
          handleSuccessSubmit={handleSuccessSubmit}
          email={email}
          password={password}
          user_id={user_id}
          verifyType="email"
          length={6}
        />
      )}
      {onSubmit && (
        <VerifiedAccount
          show={onSubmit}
          onHide={onCloseIconClick}
          onDoneButtonClick={onDoneButtonClick}
        />
      )}
    </div>
  );
};
export default EmailVerificationDialog;
